"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = exports.Wrapper = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var Wrapper = (0, _styled.default)('div')(function (_ref) {
  var _ref$theme = _ref.theme,
      space = _ref$theme.space,
      colors = _ref$theme.colors,
      menuFooter = _ref$theme.menuFooter;
  return {
    background: colors[menuFooter.backgroundColor],
    border: 'none',
    color: colors[menuFooter.textColor.social],
    padding: "".concat(space.small, " 0 ").concat(space.xxlarge)
  };
});
exports.Wrapper = Wrapper;
var _default = Wrapper;
exports.default = _default;